export default __webpack_public_path__ + "static/media/ONT-OIAA-logo.9ffa9f0b.png";